import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import PromoCode from '../../components/payment/PromoCode/PromoCode';

const mapStateToProps = state => ({
  promotionCode: state.payment.promotionCode,
  validatedPromoCode: state.payment.validatedPromoCode
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    validatePromoCode: SignupPaymentAction.validatePromoCode
  }, dispatch);


const PromoCodeContainer = connect(mapStateToProps, mapDispatchToProps)(PromoCode);

export default PromoCodeContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/PromoCodeContainer.js
 **/